export default __webpack_public_path__ + "locales/si/EmptyTrashDialog.json?hash=7fd2f015466995f464a7add52bc6f2d9";